// generated from 8_130 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastUsedSpecificAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_used_specific_app_filter"),
  comparison_key: z.enum([
    "4", // 6_689 (82.28%)
    "3", // 637 (7.84%)
    "6", // 626 (7.70%)
    "5", // 178 (2.19%)
  ]),
  display_name: z.object({
    // undefined: 8_127 (99.96%), defined 3 (0.04%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 5_414 (66.59%), defined 2_716 (33.41%)
  raw_value: z
    .union([
      // number samples: 2_394 (88.14%)
      // integer: 2_305 (96.28%)
      // avg: 53.21, min: 0, max: 720
      z.number().min(0),
      // string samples: 322 (11.86%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 7_315 (89.98%)
    // integer: 7_185 (98.22%)
    // avg: 63.37, min: 0, max: 2100
    z.number().min(0),
    // string samples: 815 (10.02%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
